export function getPrice(state, component) {
    if (state.options.alwaysAvailable) {
        return 10;
    }

    // Does it have a SKU?
    if (state.products && component?.custom?.['fun-sku']) {
        const product = state.products[component.custom['fun-sku']];

        if (product) {
            return product.price;
        }
    }

    if (state?.options?.isKiosk) {
        if (component.price) {
            return component.price[0]?.value;
        }
    }

    if (component.placementIndependentCode === 'POPMain') {
        return 0;
    }

    return null;
}

function popControllers(state) {
    if (state.mainController == null) {
        return [];
    }

    const pops = [];

    state.mainController.forAllControllers((c) => {
        if (c !== state.mainController) {
            pops.push(c);
        }
    });

    if (pops.length === 0) {
        pops.push(state.mainController);
    }

    return pops;
}

export function getInventory(state, component, controller) {
    if (component.description) {
        // eslint-disable-next-line no-restricted-syntax
        for (const d of component.description) {
            const option = controller?.blueprint.options.find((x) => x.code === d.code);

            if (option?.inventory != null) {
                return option.inventory;
            }
        }
    }

    return component.inventory;
}

export function getAts(state, component, controller) {
    // eslint-disable-next-line prefer-destructuring
    const ecommerce = state.ecommerce;

    if (ecommerce.options.alwaysAvailable) {
        return 10000;
    }

    if (component?.custom['fun-no-inventory'] === 'true') {
        return 10000;
    }

    let externalInventory = false;

    if (!ecommerce?.options?.isKiosk) {
        externalInventory = true;
    }

    if (ecommerce?.options?.isKiosk && ecommerce?.options?.kioskInventoryLocation?.length > 0) {
        externalInventory = true;
    }

    if (externalInventory) {
        // Collect available locations.
        // Except for this placement.
        const controllers = popControllers(state.customizer);
        const thisPlacement = controller.findComponentPlacement(component.code);

        if (popControllers.length === 0) {
            popControllers.push(controller);
        }

        const locations = new Set();
        const blockedLocations = new Set();

        // eslint-disable-next-line no-restricted-syntax
        for (const pop of controllers) {
            // eslint-disable-next-line no-restricted-syntax
            for (const s of pop.state) {
                if (s.placement.code === thisPlacement.code) {
                    // eslint-disable-next-line no-continue
                    continue;
                }

                if (s.component.custom?.['fun-sku']) {
                    const record = ecommerce.products[s.component.custom['fun-sku']];
                    if (record) {
                        if (record.inventoryByLocation) {
                            // eslint-disable-next-line no-restricted-syntax
                            for (const location of Object.keys(record.inventoryByLocation)) {
                                if (record.inventoryByLocation[location] && record.inventoryByLocation[location].ats > 0) {
                                    locations.add(location);
                                }

                                if (record.inventoryByLocation[location]
                                    && (record.inventoryByLocation[location].ats == null || record.inventoryByLocation[location].ats <= 0)) {
                                    blockedLocations.add(location);
                                }
                            }
                        }
                    }
                }
            }
        }

        // eslint-disable-next-line no-restricted-syntax
        for (const blocked of blockedLocations) {
            locations.delete(blocked);
        }

        // Does it have a SKU?
        if (ecommerce.products && component?.custom?.['fun-sku']) {
            const product = ecommerce.products[component.custom['fun-sku']];

            if (product) {
                // Do we have locations?
                if (locations.size > 0) {
                    // Do this product have per location data?
                    if (product.inventoryByLocation) {
                        // eslint-disable-next-line no-restricted-syntax
                        for (const l of locations) {
                            const ats = product.inventoryByLocation[l];
                            if (ats != null && ats.ats != null && ats.ats > 0) {
                                return ats.ats;
                            }
                        }

                        return false;
                    }
                }

                if (product.ats === 0 && product.ato != null) {
                    return product.ato;
                }

                if (product.ats == null) {
                    return 0;
                }

                return product.ats;
            }

            // If it has a SKU, it's a purchasable component.
            // If it is not in the list, assume that it is out of stock.
            return 0;
        }

        // Does it have a SKU?
        if (ecommerce.products && component?.custom?.['fun-shadow-sku']) {
            const product = ecommerce.products[component.custom['fun-shadow-sku']];

            if (product) {
                if (product.ats === 0 && product.ato != null) {
                    return product.ato;
                }

                if (product.ats == null) {
                    return 0;
                }

                return product.ats;
            }

            // If it has a SKU, it's a purchasable component.
            // If it is not in the list, assume that it is out of stock.
            return 0;
        }
    }

    // Fallback to internal inventory.
    return getInventory(state, component, controller);
}
